import { CancelConfirmModal } from 'app/components/cancel-confirm-modal';

interface EventCancelModalProps {
  isOpen: boolean;
  eventName: string;
  /** Formatted "Tomorrow · 5:30 pm". */
  when: string;
  isCancelling: boolean;
  isError: boolean;
  onConfirm: () => void;
  /** Keep the booking / dismiss (overlay click, Esc, or the "Keep booking" button). */
  onClose: () => void;
}

/**
 * Cancel-confirmation for an event booking. Copy and test-id prefix only; {@link CancelConfirmModal}
 * owns the shape.
 *
 * The shared error line earns its keep here in particular: the deadline the tile gated on is a
 * publish-time snapshot, so the service can still refuse a cancellation the button offered.
 */
export const EventCancelModal = ({
  isOpen,
  eventName,
  when,
  isCancelling,
  isError,
  onConfirm,
  onClose,
}: EventCancelModalProps): JSX.Element => (
  <CancelConfirmModal
    isOpen={isOpen}
    namespace="eventCancel"
    testIdPrefix="event-cancel"
    subject={{ event: eventName }}
    when={when}
    isCancelling={isCancelling}
    isError={isError}
    onConfirm={onConfirm}
    onClose={onClose}
  />
);
